<template>
  <router-view />
</template>

<script>
export default {
  name: 'VProcess'
}
</script>
